import {
  Button,
  ListItemIcon,
  listItemIconClasses,
  ListItemText,
  MenuItem,
} from '@mui/material';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { useContext } from 'react';
import { DataContext } from '../contexts/DataContext';
import { useNavigate } from 'react-router';
import { AuthContext } from '../contexts/AuthContext';

type LogoutButtonMode = 'mainMenu' | 'sideMenu';

export default function LogoutButton({
  mode,
  handleMenuClose,
}: Readonly<{
  mode: LogoutButtonMode;
  handleMenuClose?: () => void;
}>) {
  const authCtx = useContext(AuthContext);
  const dataCtx = useContext(DataContext);
  const navigate = useNavigate();
  const localHandleLogout = async () => {
    dataCtx.handleBackdropOpen();
    await authCtx.handleLogout();
    navigate('/login');
    dataCtx.handleBackdropClose();
  };

  switch (mode) {
    case 'mainMenu':
      return (
        <MenuItem
          onClick={async () => {
            handleMenuClose!();
            await localHandleLogout();
          }}
          sx={{
            [`& .${listItemIconClasses.root}`]: {
              ml: 'auto',
              minWidth: 0,
            },
          }}>
          <ListItemText>Logout Now</ListItemText>
          <ListItemIcon>
            <LogoutRoundedIcon fontSize="small" />
          </ListItemIcon>
        </MenuItem>
      );
    case 'sideMenu':
      return (
        <Button
          onClick={async () => {
            dataCtx.setDrawerOpen(false);
            await localHandleLogout();
          }}
          variant="outlined"
          fullWidth
          startIcon={<LogoutRoundedIcon />}>
          Logout
        </Button>
      );
  }
}
